<template>
  <div :class="`text-center empty-results ${
                  isTableInModal ? 'my-3' : 'my-5'
                }`">
    <div
      v-if="isTableInModal || performedSearch || automaticPerformedSearch"
      class="d-flex flex-column align-items-center text-center mb-1"
    >
      <span class="mb-4">Non sono stati trovati risultati</span>
      <b-button
        :class="`btn--smaller btn--transparent align-items-center gap-3${
                    filterCount ? ' active' : ''
                  }`"
        size="sm"
        v-if="!isTableInModal"
        title="Apri i filtri"
        data-type="special-btn"
        v-b-toggle.sidebar-1
      >
        <base-icon name="filters" width="23" height="23"/>
        Ricerca con
        filtri{{ filterCount ? ` (${filterCount})` : "" }}
      </b-button>
    </div>

    <template v-else-if="!isTableInModal">
      <span>Clicca qui per aprire i filtri ed effettuare una nuova ricerca</span>
      <b-button
        :class="`btn--smaller btn--transparent align-items-center gap-3${
                    filterCount ? ' active' : ''
                  }`"
        size="sm"
        title="Apri i filtri"
        data-type="special-btn"
        v-b-toggle.sidebar-1
      >
        <base-icon name="filters" width="23" height="23"/>
        Ricerca con filtri{{ filterCount ? ` (${filterCount})` : "" }}
      </b-button>
    </template>
  </div>
</template>

<script>
import BaseIcon from "@/components/BaseIcon";

export default {
  name: 'EmptyTable',
  components: {
    BaseIcon,
  },
  props: {
    isTableInModal: {
      type: Boolean,
      default: false
    },
    performedSearch: {
      type: Boolean,
      default: false
    },
    automaticPerformedSearch: {
      type: Boolean,
      default: false
    },
    filterCount: {
      type: Number,
      default: 0
    }
  }
}
</script>